/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Getting_Started__Question_2Inputs */

const en_help_center__getting_started__question_2 = /** @type {(inputs: Help_Center__Getting_Started__Question_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I join my first battle?`)
};

/**
* | output |
* | --- |
* | "How do I join my first battle?" |
*
* @param {Help_Center__Getting_Started__Question_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__getting_started__question_2 = /** @type {((inputs?: Help_Center__Getting_Started__Question_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Getting_Started__Question_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__getting_started__question_2(inputs)
});